<template>
  <div class="cargo-details-truck">
    <div class="title custom-title">Cargo Details</div>

    <validation-observer name="Cargo-truck" ref="validateCargoTruck">
      <b-card class="b-card-bg">
        <b-row class="mb-2">
          <b-col lg="3">
            <label>Booking No.</label>
            <b-form-input
              :disabled="readonly"
              class="iuput"
              v-model="value.cargo_booking"
              placeholder="Enter Booking No."
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row
          v-for="vanContainer in value.valueVan"
          :key="vanContainer.id"
          class="mt-1"
        >
          <b-col lg="3">
            <validation-provider
              name="Container Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Truck Type
                  <div class="red">*</div></label
                >
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  :disabled="readonly"
                  placeholder="Truck Type"
                  :settings="{
                    allowClear: true,
                  }"
                  v-model="vanContainer.truck_type"
                  :options="cont_types.filter((i) => i.group === 'van truck')"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="3">
            <validation-provider
              name="Quantity"
              #default="{ errors }"
              rules="required|minNumber:0"
            >
              <b-form-group>
                <label class="flex"
                  >Quantity
                  <div class="red">*</div>
                </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  @input="updateVanLine3(vanContainer)"
                  class="iuput"
                  v-model="vanContainer.quantity"
                  type="text"
                  placeholder="Quantity"
                  required
                ></b-form-input>
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col lg="3">
            <validation-provider
              name="Commodity Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Commodity Type
                  <div class="red">*</div></label
                >
                <Select2
                  :disabled="readonly"
                  placeholder="Select Commodity type"
                  v-model="vanContainer.commodity_type"
                  :options="goods_types"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col class="mt-20" v-if="!readonly">
            <div v-if="!vanContainer.hasDelete" class="custom-add-line">
              <b-img
                width="30px"
                @click="handleAddContainer"
                :src="iconAdd"
                alt="logo"
              />
            </div>

            <div v-if="vanContainer.hasDelete" class="custom-delete">
              <b-img
                width="30px"
                @click="handleDeleteVanContainer(vanContainer.id)"
                :src="remove"
                alt="logo"
              />
            </div>
          </b-col>
          <b-col lg="12">
            <b-row
              v-for="itemVanLine in vanContainer.VanLine"
              :key="itemVanLine.id"
              class="mt-1"
            >
              <b-col>
                <validation-provider
                  name="Commodity"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="flex"
                      >Commodity
                      <div class="red">*</div>
                    </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      class="iuput"
                      v-model="itemVanLine.commodity"
                      type="text"
                      placeholder="Commodity"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col>
                <validation-provider
                  name="Total packages"
                  #default="{ errors }"
                  rules="required|minNumber:0"
                >
                  <b-form-group>
                    <label class="flex"
                      >Total packages
                      <div class="red">*</div>
                    </label>
                    <cleave
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      :options="$Utils.CONSTANTS.cleaveNumeral"
                      v-model="itemVanLine.total_package"
                      class="form-control"
                      placeholder="Total packages"
                      required
                    />
                    <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    class="iuput"
                    v-model="itemVanLine.total_package"
                    type="text"
                    placeholder="Total packages"
                    required
                  ></b-form-input> -->
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col class="custom-grid">
                  <validation-provider
                    name="Package type"
                    #default="{ errors }"
                    rule="required"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Package type
                        <div class="red">*</div></label
                      >

                      <Select2
                        :disabled="readonly"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        placeholder="Package type"
                        v-model="itemVanLine.package_type"
                        :options="
                          cont_types.filter((i) => i.group === 'packaging')
                        "
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <label>Dimension (cm)</label>

                  <div class="flex">
                    <validation-provider
                      name="Dimension"
                      #default="{ errors }"
                      rules="minNumber:0"
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly"
                          class="iuput"
                          v-model="itemVanLine.dimension.lenght"
                          type="number"
                          placeholder="L (cm)"
                          required
                        ></b-form-input>

                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      name="Dimension"
                      #default="{ errors }"
                      rules="minNumber:0"
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly"
                          class="iuput"
                          v-model="itemVanLine.dimension.width"
                          type="number"
                          placeholder="W (cm)"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                      name="Dimension"
                      #default="{ errors }"
                      rules="minNumber:0"
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly"
                          class="iuput"
                          v-model="itemVanLine.dimension.height"
                          type="number"
                          placeholder="H (cm)"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </div>
                </b-col>
              <!-- <b-col class="custom-grid">
                <validation-provider
                  name="Dimension"
                  #default="{ errors }"
                  rules="minNumber:0"
                >
                  <b-form-group>
                    <label>Dimension (cm)</label>

                    <div class="flex">
                      <b-form-input
                        :disabled="readonly"
                        class="iuput"
                        v-model="itemVanLine.dimension.lenght"
                        type="number"
                        placeholder="L (cm)"
                        required
                      ></b-form-input>
                      <b-form-input
                        :disabled="readonly"
                        class="iuput"
                        v-model="itemVanLine.dimension.width"
                        type="number"
                        placeholder="W (cm)"
                        required
                      ></b-form-input>
                      <b-form-input
                        :disabled="readonly"
                        class="iuput"
                        v-model="itemVanLine.dimension.height"
                        type="number"
                        placeholder="H (cm)"
                        required
                      ></b-form-input>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col> -->
              <b-col>
                <validation-provider
                  name="Total gross weight (Kgs)"
                  #default="{ errors }"
                  rules="required|minNumber:0"
                >
                  <b-form-group>
                    <label class="flex"
                      >Total gross weight (Kgs)
                      <div class="red">*</div>
                    </label>
                    <cleave
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      :options="$Utils.CONSTANTS.cleaveNumeral"
                      v-model="itemVanLine.total_gross_weight"
                      class="form-control"
                      placeholder="Total gross weight (Kgs)"
                      required
                    />
                    <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    class="iuput"
                    v-model="itemVanLine.total_gross_weight"
                    type="text"
                    placeholder="Total gross weight (Kgs)"
                    required
                  ></b-form-input> -->
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col>
                <validation-provider
                  name="Total volume (cbm)"
                  #default="{ errors }"
                  rules="minNumber:0"
                >
                  <b-form-group>
                    <label class="flex">Total volume (cbm) </label>
                    <cleave
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      :options="$Utils.CONSTANTS.cleaveNumeral"
                      v-model="itemVanLine.total_volume"
                      class="form-control"
                      placeholder="Total volume (cbm)"
                      required
                    />
                    <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    class="iuput"
                    v-model="itemVanLine.total_volume"
                    type="text"
                    placeholder="Total volume (cbm)"
                    required
                  ></b-form-input> -->
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="0.5" class="mt-20">
                <div
                  v-if="!itemVanLine.hasDelete && !readonly"
                  class="custom-add-line"
                >
                  <b-img
                    width="30px"
                    @click="handleAddLineVan(vanContainer.id)"
                    :src="iconAdd"
                    alt="logo"
                  />
                </div>
                <div
                  v-if="itemVanLine.hasDelete && !readonly"
                  class="custom-delete"
                >
                  <b-img
                    width="30px"
                    @click="
                      handleDeleteLineVan(vanContainer.id, itemVanLine.id)
                    "
                    :src="remove"
                    alt="logo"
                  />
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import {
  BButton,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    Select2,
  },
  data() {
    return {
      iconAdd: require("@/assets/images/icons/add.png"),
      remove: require("@/assets/images/icons/remove.png"),
      check_country_pick_up: null,
      check_country_delivery: null,
    };
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
      "quotations",
      "locations",
    ]),
  },
  watch: {
   
  },
  mounted() {
   
  },
  methods: {
    handleAddContainer() {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID2 =
        Math.random().toString(30).substr(1, 8) + "-" + Date.now();
      const newElement = {
        id: randomID,
        hasDelete: true,
        truck_type: null,
        quantity: null,
        commodity_type: null,

        VanLine: [
          {
            id: randomID2,
            hasDelete: false,
            commodity: null,
            total_gross_weight: null,
            total_package: null,
            total_volume: null,
            dimension: {
              length: null,
              width: null,
              height: null,
            },
          },
        ],
      };
      this.value.valueVan.push(newElement);
    },
    handleDeleteVanContainer(id) {
      this.value.valueVan = this.value.valueVan.filter(
        (item) => item.id !== id
      );
    },
    handleAddLineVan(id) {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const index = this.value.valueVan.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.value.valueVan[index].VanLine.push({
          id: randomID,
          hasDelete: true,

          commodity: null,
          total_gross_weight: null,
          total_package: null,
          total_volume: null,
          dimension: {
            length: null,
            width: null,
            height: null,
          },
        });
      }
    },
    handleDeleteLineVan(id, id2) {
      for (let i = 0; i < this.value.valueVan.length; i++) {
        const currentObj = this.value.valueVan[i];
        if (currentObj.id === id) {
          currentObj.VanLine = currentObj.VanLine.filter(
            (item) => item.id !== id2
          );
        }
      }
    },
  },
};
</script>

<style lang="scss">
.cargo-details-truck {
  .custom-grid {
    flex: 0 0 19.5%;
    max-width: 19.3%;
    @media (max-width: 992px) {
      flex: 0 0 50%;
      max-width: 50%;
      margin: 0 0px;
    }
    .flex {
      display: flex;
      gap: 5px;
    }
  }
  .custom-title {
    align-items: center;
    display: flex;
    height: 43px;
  }
  .container-checkbox {
    display: flex;
    margin-top: 29px;
    align-items: center;
    gap: 5px;
  }
  label {
    color: #000000;
    font-weight: 600;
  }
  .form-control {
    border: 0 !important;
  }
  .b-card-bg {
    height: auto;
    padding: 1.5rem;
    @media (max-width: 992px) {
      height: 350px;
    }
  }
  .mx-input {
    border: none !important;
  }
  .mt-20 {
    margin-top: 25px;
  }
  .custom-delete {
    margin-top: 5px;
    cursor: pointer;
  }
  .custom-add-line {
    cursor: pointer;
  }
  .select2-selection--single {
    border: none !important;
  }
  .select2-selection--single:before {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }
}
</style>
